(function(){
  function initUpload(root){
    var cloudName=root.getAttribute('data-cloud-name');
    var preset=root.getAttribute('data-upload-preset');
    var maxFiles=parseInt(root.getAttribute('data-max-files')||'10',10);
    var required=root.getAttribute('data-required')==='true';
    var endpoint='https://api.cloudinary.com/v1_1/'+encodeURIComponent(cloudName)+'/image/upload';
    var input=root.querySelector('[data-tempvs-file-input]');
    var preview=root.querySelector('[data-tempvs-preview]');
    var status=root.querySelector('[data-tempvs-status]');
    var hidden=root.querySelector('[data-tempvs-photo-links]');
    var form=root.closest('form');
    var submit=form?form.querySelector('[type="submit"]'):null;
    var uploading=false;

    if(!input||!cloudName||!preset)return;
    input.disabled=false;
    root.classList.remove('TempvsUpload--disabled');

    function setBusy(busy){
      uploading=busy;
      if(submit){
        submit.disabled=busy;
        if(busy){submit.setAttribute('data-original-text',submit.textContent);submit.textContent='Uploading photographs…';}
        else if(submit.hasAttribute('data-original-text')){submit.textContent=submit.getAttribute('data-original-text');submit.removeAttribute('data-original-text');}
      }
    }

    input.addEventListener('change',async function(){
      var allFiles=Array.prototype.slice.call(input.files||[]);
      preview.innerHTML='';
      hidden.value='';
      status.textContent='';

      if(allFiles.length>maxFiles){
        status.textContent='Please choose no more than '+maxFiles+' images.';
        input.value='';
        return;
      }
      if(!allFiles.length)return;

      for(var x=0;x<allFiles.length;x++){
        if(allFiles[x].size>10*1024*1024){
          status.textContent='Each image must be 10 MB or smaller.';
          input.value='';
          return;
        }
      }

      setBusy(true);
      status.textContent='Uploading '+allFiles.length+' image'+(allFiles.length>1?'s':'')+'…';
      var urls=[];

      try{
        for(var i=0;i<allFiles.length;i++){
          var f=allFiles[i];
          var tile=document.createElement('div');
          tile.className='TempvsUpload__Thumb';
          var img=document.createElement('img');
          img.alt=f.name;
          img.src=URL.createObjectURL(f);
          tile.appendChild(img);
          preview.appendChild(tile);

          var fd=new FormData();
          fd.append('file',f,f.name);
          fd.append('upload_preset',preset);

          var res=await fetch(endpoint,{method:'POST',body:fd});
          if(!res.ok){
            var msg='Upload failed';
            try{var err=await res.json();if(err&&err.error&&err.error.message)msg=err.error.message;}catch(e){}
            throw new Error(msg);
          }
          var data=await res.json();
          if(!data.secure_url)throw new Error('Cloudinary did not return an image URL');
          urls.push(data.secure_url);
        }
        hidden.value=urls.join('\n');
        status.textContent=urls.length+' photograph'+(urls.length>1?'s':'')+' uploaded successfully.';
      }catch(err){
        hidden.value='';
        status.textContent='We could not upload the photographs. Please try again.';
      }finally{
        setBusy(false);
      }
    });

    if(form){
      form.addEventListener('submit',function(e){
        if(uploading){
          e.preventDefault();
          status.textContent='Please wait for the photographs to finish uploading.';
          return;
        }
        if(required && !hidden.value.trim()){
          e.preventDefault();
          status.textContent='Please upload at least one photograph before submitting.';
          root.scrollIntoView({behavior:'smooth',block:'center'});
        }
      });
    }
  }
  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('.TempvsUpload').forEach(initUpload);
  });
})();